module.exports = __webpack_public_path__ + "static/media/bubble-01.16503452.png";